<template>
  <div class="content">
    <div class="container-fluid mt-4">
      <h3>Upload Training Data</h3>
      <router-view @drop="onDrop" :files="files"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    files: [],
  }),
  methods: {
    onDrop(files) {
      this.files = new Array(...files)
      this.$router.push('/training')
    },
  },
  watch: {
    $route(val) {
      if (val.path !== '/training') {
        this.files = []
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
